export default {
    'OPERACION_OFIC': (state, mutation) => {
        state.oficina = mutation.oficina
    }
}